import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { UserConfigurationMapper } from "@app/core/user/data/network/user-configuration-ws.mapper";
import { UserConfiguration } from "@app/core/user/domain/user-configuration";

@Injectable({
  providedIn: "root",
})
export class PostUserConfigurationWS {
  constructor(private handler: BaseHandler) {}

  execute(params: {token: string, userConfiguration: Record<string,any>}): Observable<UserConfiguration> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(params.token))
      .setUrl(ApiUrls.GET_USER_CONFIGURATION_ENDPOINT())
      .setBody(params.userConfiguration)
      .build();
    return this.handler.execute(parameters)
  }
}
